import React from "react"

import { ContentTag, Obj, Widget } from "scrivito"
import { WithClassName } from "shared/types/WithClassName"
import { ImageList } from "shared/ui/image/ImageList"

export const ScrivitoImageWidgetList = React.memo(
  (
    props: React.ComponentProps<typeof ContentTag> & {
      content: Obj | Widget | null
      attribute: string
      isLoading?: boolean
    } & WithClassName
  ) => {
    const { isLoading, ...rest } = props

    return (
      <ImageList isLoading={isLoading}>
        <ContentTag {...rest} className="image-widget-list" />
      </ImageList>
    )
  }
)
